import * as React from 'react';
import { useTheme } from '../../../../../theme';

const DummyPriceGraph: React.FunctionComponent = () => {
	const theme = useTheme('Results').DummyPriceGraph;

	return (
		<div className={theme.container}>
			<div className={theme.header} />

			<div className={theme.calendar}>
				<div className={theme.daysWrapper}>
					<div className={theme.legends}>
						<div className={theme.line}>
							<div className={theme.label} />
						</div>
					</div>

					<div className={theme.days}>
						{[...Array(32).keys()].map(i => (
							<div className={theme.day} key={i}>
								<div className={theme.bar}>
									<div className={theme.progress} />
								</div>

								<div className={theme.day__header} />
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DummyPriceGraph;
